/**
 * The application's own pages, in the order they are offered. One list, because two things render them: the
 * row of buttons in the top bar, and the menu that row becomes on a narrow screen.
 */
export interface NavItem {
  to: string;
  labelKey: string;
  icon: string;
}

export const NAV_ITEMS: readonly NavItem[] = [
  { to: '/', labelKey: 'nav.qrCodes', icon: 'pi-qrcode' },
  { to: '/vcard', labelKey: 'nav.contactCard', icon: 'pi-id-card' },
  { to: '/bulk', labelKey: 'nav.bulkEdit', icon: 'pi-file-import' },
  { to: '/groups', labelKey: 'nav.usersAndGroups', icon: 'pi-users' },
];

/** The page that has nothing on it for somebody who is in no group. */
export const GROUPS_ITEM = '/groups';

export const BULK_ITEM = '/bulk';
